export const ptBR = {
    panelTitle: "Painel do Assessor",
    managerPanelTitle: "Painel do Gerente",
    rankingSectionTitle: "Ranking de produtos por mercado",
    rankingPreviewShow: "Ver rankings de produtos por mercado",
    rankingPreviewHide: "Ocultar rankings de produtos por mercado",
    rankingPreviewLoadError: "Não foi possível carregar os rankings do servidor.",
    rankingPreviewNotConfigured: "Nenhum critério definido.",
    rankingPreviewEditedMeta: "Última edição: {name} · {date}",
    rankingEditForbidden: "Apenas gerentes podem alterar rankings. Use o Painel do Gerente.",
    rankingViewProperties: "Ver propriedades do ranking",
    rankingHideProperties: "Ocultar propriedades do ranking",
    rankingPropertiesModalTitle: "Propriedades — {market}",
    rankingPropertiesLoadError: "Não foi possível carregar as propriedades do ranking.",
    rankingPropertiesEmpty: "Nenhuma propriedade disponível para este mercado.",
    rankingPropertiesClickHint:
        "Clique em uma propriedade ou valor para montar o critério no campo abaixo.",
    rankingPropertiesExpandModal: "Expandir",
    rankingPropertyHigher: "maior",
    rankingPropertyLower: "menor",
    rankingPropertyFilterGt: "maior que…",
    rankingPropertyFilterLt: "menor que…",
    rankingPropertyFilterValuePlaceholder: "Valor",
    rankingPropertyFilterApply: "Inserir",
    rankingPropertyFilterCancel: "Cancelar",
    rankingPropertyFilterInvalidValue: "Informe um número válido.",
    rankingPropertyYes: "sim",
    rankingPropertyNo: "não",
    rankingChatPlaceholder: "Ex.: maior retorno, menor liquidez… (use as propriedades acima)",
    chatMessageSendError: "Não foi possível enviar sua mensagem. Tente novamente.",
    opportunitiesOnManagerPanel:
        "Oportunidades e criação de novas metas ficam no Painel do Gerente. Use a aba acima para alternar.",
    clientsOverview: "Visão geral de clientes",
    volumeUnderCustody: "Volume sob custódia",
    opportunities: 'Oportunidades',
    welcomeText1: "Bem vindo de volta",
    todayIs: "Hoje é",
    itIsTime: "São",
    seeMore: "Ver mais",
    seeClients: "Ver Clientes",
    contextMessage: "Contextualizado",
    commitments: "Compromissos",
    nextContributionPerClient: "Próximos vencimentos e aportes de clientes",
    top3Clients: "Top 3 clientes em patrimônio",
    clientsTotal: "Total de clientes",
    addObjective: "Adicionar Objetivo",
    addNewOpportunity: "Adicionar nova oportunidade",
    objectiveDraftModalTitle: "Novo objetivo",
    objectiveDraftReviewTitle: "Rever rascunho",
    objectiveDraftIntro:
        "Descreva a estratégia em linguagem natural. Vamos gerar um rascunho: a IA propõe interpretação e consulta (Cypher) só para leitura. Depois pode ajustar o texto e regerar, ou confirmar para gravar.",
    objectivePromptLabel: "Estratégia (prompt)",
    objectivePromptHelper:
        "Este é o texto principal que a IA usa para entender o objetivo e estimar impacto. Quanto mais claro, melhor o rascunho.",
    objectiveReportTitleLabel: "Nome do relatório (opcional)",
    objectiveCardStrategyLabel: "Estratégia",
    objectiveValidityLabel: "Validade (dias)",
    objectiveValiditySuffix: "dias",
    objectiveGenerateDraftButton: "Gerar rascunho",
    objectiveReviewHeading: "Revisão do rascunho (nada foi gravado ainda)",
    objectiveExpiresHint: "Este rascunho expira em",
    objectiveInterpretationHeading: "O que a IA entendeu",
    objectiveCypherHeading: "Consulta gerada (somente leitura)",
    objectiveImpactedPreviewHeading: "Pré-visualização de impacto",
    objectiveImpactedCount: "Total de linhas estimadas",
    objectiveWarningsHeading: "Alertas",
    objectiveStrategyAdjustLabel: "Ajustar texto da estratégia e regerar",
    objectiveRegenerateButton: "Regerar rascunho",
    objectiveCommitButton: "Confirmar e gravar objetivo",
    objectiveBackToFormButton: "Voltar ao formulário",
    objectivePreviewEmpty: "Sem linhas no pré-visualizador.",
    objectiveDraftCannotCommit:
        "A consulta não foi validada. Ajuste a estratégia ou regenere o rascunho antes de confirmar.",
    objectiveCommitSuccess: "Objetivo criado com sucesso.",
    objectiveMonitoringBadge: "Monitoramento",
    objectiveSeeByPortfolio: "Ver por carteira",
    objectiveHidePortfolio: "Ocultar carteiras",
    objectiveMonitorAction: "Monitorar",
    objectiveMonitorCollapse: "Ocultar",
    objectiveMonitoringMeta: "{portfolioCount} carteiras · {movementCount} movimentos",
    objectiveMonitoringSummary: "Resumo",
    objectiveMonitoringPortfolioCol: "Carteira",
    objectiveMonitoringAdvisorCol: "Assessor",
    objectiveMonitoringAmountCol: "Valor executado",
    objectiveMonitoringOpportunityTotalCol: "Valor oportunidade (Ver Clientes)",
    objectiveMonitoringPercentDoneCol: "Percentual executado",
    objectiveMonitoringNA: "N/A",
    objectiveMonitoringSortHintDesc: "Ordenado: maior % feito primeiro",
    objectiveMonitoringSortHintAsc: "Ordenado: menor % feito primeiro",
    objectiveMonitoringSortToggleAria: "Inverter ordem da coluna percentual feito",
    objectiveMonitoringNoAdvisor: "Sem assessor",
    objectiveMonitoringGroupModePortfolio: "Ver por carteira",
    objectiveMonitoringGroupModeAdvisor: "Ver por assessor",
    objectiveMonitoringGroupModeAria: "Alternar entre visão por carteira ou por assessor",
    objectiveMonitoringEmpty:
        "Sem dados de monitoramento por carteira para este objetivo (ou consulta de movimento não armazenada).",
    objectiveMonitoringRollupsHint:
        "Carregue os dados agregados por carteira uma vez para ver movimentação neste e nos demais objetivos com monitoramento.",
    dueDate: "Validade",
    addedAt: "Adicionado em",
    impactedClients: "Clientes impactados",
    dones: "feitos",
    done: "feito",
    of: "de",
    loading: "carregando",
    showMoreOpportunities: "Ver mais oportunidades",
    showLessOpportunities: "Ver menos oportunidades",
    clients: "clientes",
    hideAll: "Esconder todos",
    showAll: "Expandir todos",
    liquidityEvents: "Eventos de liquidez",
    optQuantity: "Quantidade de oportunidades",
    events: "eventos",
    event: "evento",
    reference: "referência",
    equity: "patrimônio",
    motive: "motivo",
    weekLiquidityEvent: "Evento de liquidez essa semana",
    rebalancing: "Rebalanciamento (relatório de pesquisa)",
    invSugestions: "Sugestão de investimentos",
    opportunitiesRelatedTo: "oportunidades relacionadas a",
    liquidityStream: "Fluxo de liquidez",
    maturity: "Vencimento",
    suitability: "Adequação",
    comission: "Comissão",
    product: "Produto",
    category: "Categoria",
    sugestInvestimentMsg: "Sugestão de mensagem",
    search: "Pesquisar",
    opportunityRelatedTo: "oportunidade relacionada a",
    all: "Todos",
    resolved: "Feitos",
    unresolved: "Não feitos",
    week: "Semana",
    day: "Dia",
    vencimento: "Vencimento",
    caixa: "Caixa",
    oportunidade: "Oportunidade",
    eventValueAll: "Todos",
    eventValueLow: "< 100k",
    eventValueMid: "100k - 500k",
    eventValueHigh: "> 500k",
    cashMinNominal: "Mínimo nominal (R$)",
    cashMinRelative: "Mínimo relativo (%)",
    investment: "Investimento",
    investmentDetails: "Detalhes do Investimento",
    type: "Tipo",
    liquidity: "Liquidez",
    month: "Mês",
    year: "Ano",
    m12: '12M',
    m24: '24M',
    m36: '36M',
    assetManager: "Gestor de ativos",
    cnpj: "CNPJ",
    benchmark: "Benchmark",
    effectiveReturn: "Retorno efetivo",
    public: "Público",
    minimalApplication: "Mínimo de aplicação",
    globalInterest: "Taxa global", 
    globalRate: "Taxa global",
    referenceRate: "Taxa de referência",
    yourWeek: "Sua semana",
    totalAmount: "Valor total",
    overview: "Visão geral",
    cashOnHand: "Dinheiro em caixa",
    yourClients: "Seus clientes",
}

